// extracted by mini-css-extract-plugin
export var disabled = "_1m-5";
export var error = "_1m-1";
export var fitContent = "_1m-6";
export var hasSuffix = "_1m-4";
export var iconWrapper = "_1m-b";
export var infoIconWrapper = "_1m-d _1m-b";
export var input = "_1m-a";
export var inputWrapper = "_1m-0";
export var large = "_1m-8";
export var leadingIconWrapper = "_1m-c _1m-b";
export var measureBox = "_1m-e";
export var medium = "_1m-7";
export var readonly = "_1m-2";
export var small = "_1m-3";
export var suffix = "_1m-9";